<h2 mat-dialog-title>Confirm</h2>
<mat-dialog-content>
  <p>{{ data.question }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()" cdkFocusInitial>Cancel</button>
  <button mat-button (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
